/**
 * Main page implementation.
 */

'use strict';

var app                     = require('mag-app'),
    Panel                   = require('mag-component-panel'),
    PanelSet                = require('mag-component-panel-set'),
    Layout                  = require('mag-component-layout'),
    LayoutList              = require('mag-component-layout-list'),
    ModalMessage            = require('mag-component-modal'),
    RadioList               = require('mag-component-radio-list'),
    ScrollBar               = require('stb-component-scrollbar'),
    Footer                  = require('mag-component-footer'),
    keys                    = require('stb-keys'),

    appExit                 = require('../modules/app.exit'),
    keyboard                = require('../modules/keyboard'),
    div                     = require('../modules/div'),

    page                    = new (require('stb-component-page'))({$node: document.getElementById('pageMain')}),

    uiDefaults              = app.config.uiDefaults,
    initialStationsListData = [],
    searchResultData        = [],
    intentContext           = null,
    isModalShown            = false,

    panelSet,
    mainPanel,
    listStation,
    stationListScroll,
    $iconSearch,
    $iconFavorites,
    stationTitle,
    stationsAmountTitle,
    timerId;


/**
 * Play radio stations (use intent to player).
 *
 * @param {Object} item - item to play
 * @param {number} index - index of item to go to
 */
function playStation ( item, index ) {
    var queue = searchResultData,
        intent, intentConfig;

    intentConfig = {
        action: 'play',
        mime: 'content/audio',
        data: {
            uri:      item.url,
            title:    item.name,
            solution: item.solution || 'auto',
            mediaId:  item.id
        },
        context: intentContext,
        events: {
            stop: function () {
                intent.close();
            },
            error: function () {
                intent.close();
            },
            hide: function () {
                intentContext = null;
            },
            close: function () {
                intentContext = null;
                stationTitle.links.$index.innerText = '';
                stationTitle.links.$name.innerText  = '';
            },
            prev: function () {
                var next = queue.next;

                if ( next === undefined ) {
                    next = queue.next = queue.indexOf(item) - 1;
                } else {
                    next = queue.next = next - 1;
                }

                // Cycle
                if ( next < 0 ) {
                    next = queue.length - 1;
                }

                listStation.move(keys.up);
                playStation(queue[queue.next], queue.next + 1);
            },
            next: function () {
                var next = queue.next;

                if ( next === undefined ) {
                    next = queue.next = queue.indexOf(item) + 1;
                } else {
                    next = queue.next = next + 1;
                }

                // Cycle
                if ( next === queue.length ) {
                    next = 0;
                }

                listStation.move(keys.down);
                playStation(queue[queue.next], queue.next + 1);
            }
        }
    };

    // delete intent events depending on file position in queue,
    // disable "prev" on the first one and "next" on the last
    if ( !queue.indexOf(item) ) {
        delete intentConfig.events.prev;
    }

    if ( queue.indexOf(item) === queue.length - 1 ) {
        delete intentConfig.events.next;
    }

    intent = core.intent(intentConfig, function ( error, context ) {
        if ( !error ) {
            intentContext = context;
        }
    });

    stationTitle.links.$index.innerText = index + 1;
    stationTitle.links.$name.innerText  = item.name;
}


/**
 * Construct appropriate layout for station list from raw data.
 *
 * @param {Object[]} stations - array of radio stations
 *
 * @return {Object[]} array of ready-to-use in LayoutList objects
 */
function prepareStationsLayout ( stations ) {
    var searchPattern;

    stationsAmountTitle.links.$amount.innerText = stations.length;

    stations = stations.map(function ( station, index ) {
        return {
            items: [
                {
                    value: '' + station.date,
                    className: 'trackNumber'
                },
                {
                    value: station.name,
                    className: 'trackName'
                },
                {
                    name: '$favorites',
                    className: 'favoritesBlock theme-icon' + (station.favorite ? ' theme-icon-favorite-active active' : '')
                }
            ],
            value: {
                id:         station.id,
                isFavorite: station.favorite
            },
            click: function () {
                playStation(station, index);
            }
        };
    });

    if ( app.state.searchRequest ) {
        searchPattern = new RegExp(app.state.searchRequest, 'i');
        searchResultData = stations.filter(function ( item ) {
            return searchPattern.test(item.items[1].value);
        });

        return searchResultData;
    }

    return stations;
}


/**
 * Sorting radio stations.
 *
 * @param {Array} stations - radio stations to sort
 * @param {string} order - sorting type
 *
 * @return {Object[]} sorted array
 */
function radioChannelsSort ( stations, order ) {
    if ( !stations || !stations.length ) {
        return [];
    }

    switch ( order ) {
        case 'name':
            stations.sort((itemA, itemB) => itemA.name.toLowerCase().localeCompare(itemB.name.toLowerCase()));
            break;
        case 'number':
            stations.sort((itemA, itemB) => itemA.date - itemB.date);
            break;
    }

    return stations;
}


/**
 * Set new data/new options to page/list.
 *
 * @param {Object[]} data - array of station objects for parsing into LayoutList
 */
function renderStations ( data ) {
    data = prepareStationsLayout(radioChannelsSort(searchResultData, app.state.sortOrder));

    if ( listStation ) {
        listStation.setData({
            data: data,
            focusIndex: listStation.$focusItem && listStation.$focusItem.index < data.length ? listStation.$focusItem.index : 0
        });
    } else {
        listStation = new LayoutList({
            cycle:      true,
            propagate:  true,
            size:       7,
            scroll:     stationListScroll,
            focusIndex: 0,
            data:       data,
            noData:     gettext('No stations')
        });
    }
}


/**
 * Search at radio channels list.
 *
 * @param {string} value - search request
 */
function radioChannelsSearch ( value ) {
    var stations = initialStationsListData,
        searchPattern;

    if ( !value ) {
        if ( app.state.searchRequest ) {
            renderStations(prepareStationsLayout(initialStationsListData));
            $iconSearch.classList.remove('active');
        }

        searchResultData = stations.slice();

        return;
    }

    searchPattern = new RegExp(value, 'i');
    searchResultData = stations.filter(function ( item ) {
        return searchPattern.test(item.name);
    });

    $iconSearch.classList.add('active');
}


/**
 * Switch between active and inactive favorites states.
 */
function toggleFavorites () {
    var target     = listStation.$focusItem,
        value      = target.data.value,
        isFavorite = value.isFavorite;

    app.radioBackend.setRadioChannelFavoriteState(value.id, !isFavorite, function ( error ) {
        var favoritesBlock = target.layout.links.$favorites,
            index, dataLength;

        if ( !error ) {
            target.data.value.isFavorite = !isFavorite;
            favoritesBlock.className =
                listStation.data[listStation.$focusItem.index].items[2].className =
                    'favoritesBlock theme-icon' + (isFavorite ? '' : ' theme-icon-favorite-active active');

            // synchronize data
            for ( index = 0, dataLength = searchResultData.length; index < dataLength; index += 1 ) {
                if ( searchResultData[index].id === value.id ) {
                    searchResultData[index].favorite = !isFavorite;
                    break;
                }
            }
        }
    });
}


/**
 * Helper function for closing modal window.
 */
function closeModalWindow () {
    page.modalSorting.hide();
    page.modalResetFilters.hide();
    page.modalContextMenu.hide();
    isModalShown = false;
    panelSet.focus();
    page.footer.show();
}


/**
 * Send request to API to refresh data list.
 *
 * @param {Object} queryStringSet - set of name-value GET parameters
 */
function refreshList ( queryStringSet ) {
    app.radioBackend.getRadioChannels(queryStringSet, function ( error, data ) {
        if ( !error ) {
            setTimeout(function () {
                initialStationsListData = data;
                renderStations(radioChannelsSearch(app.state.searchRequest));
            }, 0);
        }
    });
}


/**
 * Render visible panels.
 *
 * @param {Object[]} data - array of items for LayoutList
 */
// eslint-disable-next-line
function init ( data ) {
    var dataLength = data.length,
        leftPanelFooterConfig,
        mainPanelFooterConfig,
        leftPanel,
        listSortingOption,
        $inputSearch,
        $buttonSort;


    function resetFilters () {
        if (
            app.state.searchRequest      !== uiDefaults.searchRequest
            || app.state.sortOrder       !== uiDefaults.sortOrder
            || app.state.favoritesActive !== uiDefaults.favoritesActive
        ) {
            app.state.searchRequest   = uiDefaults.searchRequest;
            app.state.sortOrder       = uiDefaults.sortOrder;
            app.state.favoritesActive = uiDefaults.favoritesActive;

            $inputSearch.innerText = gettext('Search');
            $iconSearch.classList.remove('active');

            listSortingOption.resetData();
            $buttonSort.innerText = uiDefaults.sortOrder === 'name' ? gettext('By name') : gettext('By number');

            $iconFavorites.className = 'theme-icon theme-icon-favorite';

            refreshList({favorite: app.state.favoritesActive});
        }
    }


    leftPanelFooterConfig = {
        left: {
            code: keys.menu,
            action: function () {
                page.modalResetFilters.show();
            }
        },
        middle: [{code: keys.f1, title: gettext('Reset filters'), action: resetFilters}]
    };

    mainPanelFooterConfig = {
        left: {
            code: keys.menu,
            action: function () {
                page.modalContextMenu.show();
            }
        },
        middle: [
            {code: keys.f3, title: gettext('Favorites'), action: toggleFavorites},
            {code: keys.f4, title: gettext('Search'), action: function () {
                keyboard.open({
                    title: gettext('RADIO STATION SEARCH'),
                    input: $inputSearch,
                    value: app.state.searchRequest
                }, function ( event ) {
                    renderStations(radioChannelsSearch(app.state.searchRequest = event.value));
                });
            }}
        ]
    };

    stationTitle = new Layout({
        parent: page,
        className: 'stationTitle',
        data: [
            {
                name: '$index'
            },
            {
                name: '$name'
            }
        ]
    });

    stationsAmountTitle = new Layout({
        className: 'amountContainer',
        data: [
            {
                name: '$amount',
                className: 'amount'
            }
        ]
    });

    page.footer = new Footer({
        parent:  page,
        data:    [],
        visible: true
    });

    stationListScroll = new ScrollBar({
        value:    0,
        viewSize: 7,
        realSize: dataLength
    });

    page.modalSorting = new ModalMessage({
        parent: page,
        title:  gettext('sorting'),
        events: {
            show: function () {
                page.modalSorting.focus();
                panelSet.blur();
                isModalShown = true;
                page.footer.hide();
            },
            hide: closeModalWindow
        },
        children: [
            listSortingOption = new RadioList({
                focusIndex: 0,
                size: 2,
                cycle: true,
                events: {
                    'click:item': function ( event ) {
                        page.modalSorting.hide();
                        app.state.sortOrder = event.$item.value === 1 ? uiDefaults.sortOrder : 'name';
                        renderStations(searchResultData);
                        $buttonSort.innerText = event.$item.data.title;
                    }
                },
                data: [
                    {
                        state: app.state.sortOrder !== uiDefaults.sortOrder,
                        title: gettext('By name'),
                        value: 0
                    },
                    {
                        state: app.state.sortOrder === uiDefaults.sortOrder,
                        title: gettext('By number'),
                        value: 1
                    }
                ]
            })
        ]
    });

    page.modalResetFilters = new ModalMessage({
        parent: page,
        title: gettext('actions'),
        events: {
            show: function () {
                page.modalResetFilters.focus();
                panelSet.blur();
                isModalShown = true;
                page.footer.hide();
            },
            hide: closeModalWindow
        },
        children: [
            new LayoutList({
                size: 1,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-rc-f1'
                            },
                            gettext('Reset filters')
                        ],
                        click: function () {
                            resetFilters();
                            page.modalResetFilters.hide();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);

                        if ( event.code === keys.menu ) {
                            event.stop = true;
                            page.modalResetFilters.hide();
                        }
                    }
                }
            })
        ]
    });

    page.modalContextMenu = new ModalMessage({
        parent: page,
        title:  gettext('actions'),
        events: {
            show: function () {
                page.modalContextMenu.focus();
                panelSet.blur();
                isModalShown = true;
                page.footer.hide();
            },
            hide: closeModalWindow
        },
        children: [
            new LayoutList({
                size: 1,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-rc-f3'
                            },
                            gettext('Favorites')
                        ],
                        click: function () {
                            toggleFavorites();
                            closeModalWindow();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        if ( event.code === keys.menu ) {
                            event.stop = true;
                            closeModalWindow();
                        }
                    }
                }
            })
        ]
    });

    page.footer.init();
    renderStations(data);

    page.add(
        panelSet = new PanelSet({
            panels: [
                leftPanel = new Panel({
                    size: 1,
                    title: [
                        {
                            value: gettext('menu'),
                            className: 'name'
                        }
                    ],
                    children: [
                        new LayoutList({
                            size: 4,
                            focusIndex: 0,
                            cycle: true,
                            data: [
                                {
                                    items: [
                                        $iconSearch  = div('theme-icon theme-icon-search' + (app.state.searchRequest ? ' active' : '')),
                                        $inputSearch = div('inputSearch', app.state.searchRequest || gettext('Search'))
                                    ],
                                    value: {
                                        defaultValue: gettext('Search')
                                    },
                                    click: function () {
                                        keyboard.open({
                                            title: gettext('RADIO STATION SEARCH'),
                                            input: $inputSearch,
                                            value: app.state.searchRequest
                                        }, function ( event ) {
                                            renderStations(radioChannelsSearch(app.state.searchRequest = event.value));
                                        });
                                    }
                                },
                                {
                                    items: [
                                        $iconFavorites = div('theme-icon theme-icon-favorite'),
                                        gettext('Favorites')
                                    ],
                                    click: function () {
                                        var classList = $iconFavorites.classList;

                                        refreshList({favorite: app.state.favoritesActive = !app.state.favoritesActive});

                                        classList.toggle('theme-icon-favorite');
                                        classList.toggle('theme-icon-favorite-active');
                                        classList.toggle('active');
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-sort-az'
                                        },
                                        $buttonSort = div(
                                            'theme-item-more',
                                            app.state.sortOrder === uiDefaults.sortOrder ? gettext('By number') : gettext('By name')
                                        )
                                    ],
                                    click: function () {
                                        panelSet.blur();
                                        page.modalSorting.show();
                                        page.modalSorting.focus();
                                        isModalShown = true;
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-exit'
                                        },
                                        {
                                            value: gettext('Exit')
                                        }
                                    ],
                                    click: function () {
                                        panelSet.blur();
                                        appExit.goExit(panelSet);
                                    }
                                }
                            ]
                        })
                    ]
                }),
                mainPanel = new Panel({
                    size: 2,
                    title: [
                        {
                            value: gettext('radio stations'),
                            className: 'name'
                        },
                        stationsAmountTitle
                    ],
                    main: true,
                    children: [listStation]
                })
            ]
        })
    );

    mainPanel.$body.appendChild(stationListScroll.$node);

    leftPanel.addListener('focus', function () {
        page.footer.init(leftPanelFooterConfig);
    });

    mainPanel.addListener('focus', function () {
        page.footer.init(mainPanelFooterConfig);
    });

    mainPanel.focus();
}


page.once('show', function ( event ) {
    intentContext = null;

    if ( event.data.length ) {
        initialStationsListData = event.data;
        init(searchResultData = initialStationsListData.slice());
    } else {
        init([]);
    }

    if ( app.state.favoritesActive ) {
        $iconFavorites.className = 'theme-icon theme-icon-favorite-active active';
    }
});

page.addListener('keydown', function ( event ) {
    if ( event.code === keys.back ) {
        if ( isModalShown ) {
            closeModalWindow();
        } else {
            appExit.goBack();
        }
    }
});

core.addListeners({
    show: function () {
        intentContext = null;

        // app comes back from collapsed state
        if ( timerId ) {
            refreshList({favorite: app.state.favoritesActive});
        }

        timerId = setInterval(function () {
            refreshList({favorite: app.state.favoritesActive});
        }, 24 * 60 * 60 * 1000);
    },
    hide: function () {
        clearInterval(timerId);
    }
});


module.exports = page;
